import { useState } from 'react'
import { Title } from '../../components/Title'
import ReactHowler from 'react-howler'
import ReactGA from 'react-ga4'
import { Link } from 'react-router-dom'
export const HomeChar = () => {
    const [isVoiceOn, setIsVoiceOn] = useState(false)

    const [voice, setVoice] = useState(1)
    const setCurrent = (e) => {
        setVoice(e)
    }
    return (
        <>
            <div className='my-20'>
                <Title title='Personnages' />
                <div className='mx-auto relative mt-20 md:mt-0'>
                    {isVoiceOn && (
                        <ReactHowler
                            src={`${process.env.PUBLIC_URL}/voice/chr_0${voice}.mp3`}
                            playing={isVoiceOn}
                            volume={0.3}
                            loop={false}
                            onEnd={() => setIsVoiceOn(false)}
                        />
                    )}
                    <div className='relative flex flex-col lg:flex-row items-end justify-center md:justify-between w-full mt-20 px-4'>
                        <div className='w-full lg:w-auto self-end lg:self-end px-2 lg:px-0'>
                            <div className='w-full flex flex-row lg:flex-col justify-center md:items-start items-center lg:items-center'>
                                <div className='relative -mr-4 lg:-mr-0'>
                                    <div className=''>
                                        <img
                                            className='mx-auto'
                                            src={`${process.env.PUBLIC_URL}/images/comment-bubble.png`}
                                            alt='comment bubble'
                                        />{' '}
                                    </div>
                                    <div className='max-w-[398px] absolute text-center top-1/4 -translate-y-1/4 left-1/2 -translate-x-1/2 w-[96%]'>
                                        <p className='text-shadow-char text-pbbrown font-sans chartext'>
                                            Fillette capable de parler avec les « fantômes »
                                        </p>{' '}
                                        <div className='w-4/5 lg:w-auto mx-auto'>
                                            <img
                                                className='mx-auto md:mt-4 mt-4 w-auto'
                                                src={`${process.env.PUBLIC_URL}/images/characters/char-name-marona.png`}
                                                alt='marona'
                                            />
                                        </div>{' '}
                                        {voice === 1 && isVoiceOn === true ? (
                                            <button
                                                onClick={() => {
                                                    setIsVoiceOn(false)
                                                }}
                                                className='w-auto absolute right-0 translate-x-1/2 md:translate-y-0 lg:-translate-y-1/2'
                                            >
                                                <img
                                                    className='w-[7vw] md:w-full  mx-auto'
                                                    src={`${process.env.PUBLIC_URL}/images/btn_voice_off.png`}
                                                    alt='voice off mark'
                                                />{' '}
                                            </button>
                                        ) : (
                                            <button
                                                onClick={() => {
                                                    ReactGA.event({
                                                        action: 'click',
                                                        event: 'play',
                                                        category: 'Character',
                                                        label: `Character Voice Marona`,
                                                    })
                                                    setCurrent(1)
                                                    setIsVoiceOn(true)
                                                }}
                                                className='w-auto absolute right-0 translate-x-1/2 md:translate-y-0 lg:-translate-y-1/2'
                                            >
                                                {' '}
                                                <img
                                                    className='w-[7vw] md:w-full  mx-auto'
                                                    src={`${process.env.PUBLIC_URL}/images/btn_voice.png`}
                                                    alt='voice mark'
                                                />{' '}
                                            </button>
                                        )}
                                    </div>{' '}
                                </div>
                                <div className='mx-auto'>
                                    <img
                                        src={`${process.env.PUBLIC_URL}/images/characters/marona.png`}
                                        alt='marona kv'
                                    />
                                </div>
                            </div>{' '}
                        </div>{' '}
                        <div className='w-full lg:w-auto self-start lg:self-end px-2 lg:px-0'>
                            <div className='w-full flex flex-row-reverse lg:flex-col justify-center md:items-start items-center lg:items-center'>
                                <div className='relative -ml-40 lg:-ml-0'>
                                    <div className=''>
                                        <img
                                            className='hidden lg:block mx-auto'
                                            src={`${process.env.PUBLIC_URL}/images/comment-bubble.png`}
                                            alt='comment bubble'
                                        />{' '}
                                        <img
                                            width='399px'
                                            height='226px'
                                            className='lg:hidden block mx-auto'
                                            src={`${process.env.PUBLIC_URL}/images/characters/comment-bubble-mobile-l.png`}
                                            alt='comment bubble'
                                        />{' '}
                                    </div>
                                    <div className='max-w-[390px] absolute text-center top-1/4 -translate-y-1/4 left-1/2 -translate-x-1/2 w-[90%]'>
                                        <p className='text-shadow-char text-pbbrown font-sans chartext'>
                                            Jeune fantôme toujours aux côtés de Marona pour la servir
                                        </p>{' '}
                                        <div className='w-4/5 lg:w-auto mx-auto'>
                                            <img
                                                className='mx-auto md:mt-4 mt-2 w-auto'
                                                src={`${process.env.PUBLIC_URL}/images/characters/char-name-ash.png`}
                                                alt='ash'
                                            />
                                        </div>{' '}
                                        {voice === 2 && isVoiceOn === true ? (
                                            <button
                                                onClick={() => {
                                                    setIsVoiceOn(false)
                                                }}
                                                className='w-auto absolute right-0 translate-x-1/2 '
                                            >
                                                <img
                                                    className='w-[7vw] md:w-full  mx-auto'
                                                    src={`${process.env.PUBLIC_URL}/images/btn_voice_off.png`}
                                                    alt='voice off icon'
                                                />{' '}
                                            </button>
                                        ) : (
                                            <button
                                                onClick={() => {
                                                    ReactGA.event({
                                                        action: 'click',
                                                        event: 'play',
                                                        category: 'Character',
                                                        label: `Character Voice Ash`,
                                                    })
                                                    setCurrent(2)
                                                    setIsVoiceOn(true)
                                                }}
                                                className='w-auto absolute right-0 translate-x-1/2 '
                                            >
                                                <img
                                                    className='w-[7vw] md:w-full  mx-auto'
                                                    src={`${process.env.PUBLIC_URL}/images/btn_voice.png`}
                                                    alt='voice icon'
                                                />{' '}
                                            </button>
                                        )}
                                    </div>{' '}
                                </div>
                                <div className='mx-auto'>
                                    <img src={`${process.env.PUBLIC_URL}/images/characters/ash.png`} alt='ash' />
                                </div>
                            </div>{' '}
                        </div>{' '}
                        <div className='w-full lg:w-auto lg:self-end px-2 lg:px-0'>
                            <div className='w-full flex flex-row lg:flex-col justify-center md:items-start items-center lg:items-center'>
                                <div className='relative -mr-8 lg:-mr-0'>
                                    <div className=''>
                                        <img
                                            className='mx-auto'
                                            src={`${process.env.PUBLIC_URL}/images/comment-bubble.png`}
                                            alt='A lonely Phantom girl who longs to reunite with her father.'
                                        />{' '}
                                    </div>
                                    <div className='max-w-[390px] absolute text-center top-1/4 -translate-y-1/4 left-1/2 -translate-x-1/2 w-[90%]'>
                                        <p className='text-shadow-char text-pbbrown font-sans chartext'>
                                            Petite fille fantôme à la recherche de son père
                                        </p>{' '}
                                        <div className='w-4/5 lg:w-auto mx-auto'>
                                            <img
                                                className='mx-auto md:mt-4 mt-4 w-auto'
                                                src={`${process.env.PUBLIC_URL}/images/characters/char-name-abricot.png`}
                                                alt='apricot'
                                            />
                                        </div>
                                        {voice === 3 && isVoiceOn === true ? (
                                            <button
                                                onClick={() => {
                                                    setIsVoiceOn(false)
                                                }}
                                                className='w-auto absolute right-0 translate-x-1/2 md:translate-y-0 lg:-translate-y-1/2'
                                            >
                                                <img
                                                    className='w-[7vw] md:w-full  mx-auto'
                                                    src={`${process.env.PUBLIC_URL}/images/btn_voice_off.png`}
                                                    alt='voice off icon'
                                                />{' '}
                                            </button>
                                        ) : (
                                            <button
                                                onClick={() => {
                                                    ReactGA.event({
                                                        action: 'click',
                                                        event: 'play',
                                                        category: 'Character',
                                                        label: `Character Voice Apricot`,
                                                    })
                                                    setCurrent(3)
                                                    setIsVoiceOn(true)
                                                }}
                                                className='w-auto absolute right-0 translate-x-1/2 md:translate-y-0 lg:-translate-y-1/2'
                                            >
                                                <img
                                                    className='w-[7vw] md:w-full  mx-auto'
                                                    src={`${process.env.PUBLIC_URL}/images/btn_voice.png`}
                                                    alt='voice icon'
                                                />{' '}
                                            </button>
                                        )}
                                    </div>{' '}
                                </div>
                                <div className='mx-auto'>
                                    <img
                                        src={`${process.env.PUBLIC_URL}/images/characters/apricot.png`}
                                        alt='apricot key visusal'
                                    />
                                </div>
                            </div>{' '}
                        </div>{' '}
                    </div>
                </div>{' '}
                <div className='px-8 w-4/5 mx-auto pt-8'>
                    <Link to='/characters'>
                        <img
                            className='flex justify-center mx-auto'
                            src={`${process.env.PUBLIC_URL}/images/button-char-more-fr.png`}
                            alt='more char info'
                        />{' '}
                    </Link>{' '}
                </div>
            </div>
        </>
    )
}
